import { render } from "./DotsWaveLoader.vue?vue&type=template&id=4c5a1756&scoped=true"
import script from "./DotsWaveLoader.vue?vue&type=script&lang=js"
export * from "./DotsWaveLoader.vue?vue&type=script&lang=js"

import "./DotsWaveLoader.vue?vue&type=style&index=0&id=4c5a1756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5a1756"]])

export default __exports__